<template>
    <div class="vrm-modal vrm-modal--center vrm-modal--wide mfp-with-anim">
        <div class="vrm-modal__content">
            <span class="vrm-modal__title-icon sg-vrm-icon_110_unlock-16px"></span>
            <div class="vrm-modal__title">
                {{
                    $t('teams.access_levels', {
                        i18nFallback: 'Access Levels',
                    })
                }}
            </div>
            <br />
            <p>
                {{
                    $t('teams.access_levels_description', {
                        i18nFallback: 'Below you can find different access levels information',
                    })
                }}
            </p>
            <vrm-scroll-fade class="vrm-scroll-fade--scroll-y">
                <vrm-foldable-table
                    :items="permissions"
                    key-by="id"
                    class="vrm-table--compact vrm-table--borderless vrm-table__first-col--start vrm-table--sticky-header vrm-table--sticky-first-col"
                >
                    <template v-slot:thead>
                        <tr>
                            <th>
                                {{
                                    $t('teams.members_permissions.what_can_each_role_do', {
                                        i18nFallback: 'What can each role do',
                                    })
                                }}
                            </th>
                            <th>
                                {{
                                    $t('teams.members_permissions.team_admin', {
                                        i18nFallback: 'Team admin',
                                    })
                                }}
                            </th>
                            <th>
                                {{
                                    $t('teams.members_permissions.member', {
                                        i18nFallback: 'Member',
                                    })
                                }}
                            </th>
                        </tr>
                    </template>
                    <template v-slot:main="{ item: permission }">
                        <td>
                            {{
                                $t(`teams.${permission.id}`, {
                                    i18nFallback: permission.i18nFallback,
                                })
                            }}
                        </td>
                        <td
                            v-html="parseAccess(permission[teamMembersAccessLevel.TEAM_ADMIN])"
                        ></td>
                        <td v-html="parseAccess(permission[teamMembersAccessLevel.USER])"></td>
                    </template>
                </vrm-foldable-table>
            </vrm-scroll-fade>
            <div class="sg-btn__container">
                <button class="sg-btn sg-blue" @click="onClose">
                    {{ $t('common.close', { i18nFallback: 'Close' }) }}
                </button>
            </div>
            <modal-close-handle />
        </div>
    </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import ModalCloseHandle from '@/vue/components/modals/ModalCloseHandle';
import VrmFoldableTable from '@/vue/components/molecules/VrmFoldableTable';
import VrmScrollFade from '@/vue/components/shared/VrmScrollFade';
import { teamMembersAccessLevel } from '@/vue/store/modules/installation-access-level';

@Component({
    components: { ModalCloseHandle, VrmFoldableTable, VrmScrollFade },
})
@AngularLocaleBundle('teams')
@AngularLocaleBundle('common')
export default class UserRolesGuideModal extends Vue {
    teamMembersAccessLevel = teamMembersAccessLevel;

    access = {
        NO: 0,
        YES: 1,
    };

    allRolesAllowed = {
        [this.teamMembersAccessLevel.TEAM_ADMIN]: this.access.YES,
        [this.teamMembersAccessLevel.USER]: this.access.YES,
    };

    onlyAdmin = {
        [this.teamMembersAccessLevel.TEAM_ADMIN]: this.access.YES,
        [this.teamMembersAccessLevel.USER]: this.access.NO,
    };

    get permissions() {
        return [
            {
                id: 'members_permissions.add_users',
                i18nFallback: 'Add more users to the team',
                ...this.onlyAdmin,
            },
            {
                id: 'members_permissions.remove_users',
                i18nFallback: 'Remove users from the team',
                ...this.onlyAdmin,
            },
            {
                id: 'members_permissions.add_sites',
                i18nFallback: 'Add more installations to the team',
                ...this.onlyAdmin,
            },
            {
                id: 'members_permissions.remove_sites',
                i18nFallback: 'Remove installations from the team',
                ...this.onlyAdmin,
            },
            {
                id: 'members_permissions.remove_yourself',
                i18nFallback: 'Remove yourself from the team',
                ...this.allRolesAllowed,
            },
        ];
    }

    onClose() {
        this.$emit('close');
    }

    parseAccess(access) {
        switch (access) {
            case this.access.YES:
                return '<span class="sg-vrm-icon_054_check-16px sg-color-green"></span>';
            case this.access.NO:
                return '<span class="sg-vrm-icon_055_cross-16px sg-color-red"></span>';
            default:
                return '';
        }
    }
}
</script>
